import styled from 'styled-components'
import * as shared from '~/shared';

export const DateRangeContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 30px;
    gap: 30px;
`;

export const DateSelectContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 35vw;
`;

export const Container = styled.div`
`;

export const Header = styled(shared.Header)`
    padding: 20px;
`;

export const ScreenContainer = shared.ScreenContainer;

